import { render } from "./BundleSubmissionDraft.vue?vue&type=template&id=4550609a"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"

const cssModules = {}
import style0 from "../stylesheet/index.scss?vue&type=style&index=0&module=true&lang=scss&external"
cssModules["$style"] = style0
import "./BundleSubmissionDraft.vue?vue&type=style&index=1&id=4550609a&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__